<template>
  <FormViewBase title="Reset Password">
    <template #default>
      <EmailField
        ref="email"
        label="Confirm Email"
        :value="email"
        @change="email = $event"
        data-lpignore="true"
        autocomplete="new-password"
        outlined
      />
      <SetPasswordField
        @input="newPass = $event"
        :placeholder="'New Password'"
        data-lpignore="true"
        autocomplete="new-password"
        outlined
        label="New Password"
      />
    </template>
    <template #errors>
      <v-alert v-if="!!error" type="error" text>
        {{ error }}
      </v-alert>
    </template>
    <template #actions="{ valid }">
      <SendPasswordResetButton
        v-if="error === 'This password reset link has expired.'"
        :email="email"
        title="Send reset email again"
        :disabled="!email || !valid"
        color="orange darken-3"
        :text="false"
        depressed
      />
      <v-btn
        v-else
        @click="updatePassword"
        depressed
        block
        large
        color="blue darken-2 white--text"
        :disabled="!valid"
        type="submit"
        >Update Password</v-btn
      >
    </template>
  </FormViewBase>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapActions } from 'vuex'
import FormViewBase from '@/views/FormViewBase'
import SetPasswordField from '@/components/SetPasswordField'
import EmailField from '@/components/EmailField'
import RouteNames from '@/constants/RouteNames'
import SendPasswordResetButton from '@/components/SendPasswordResetButton'

import _get from 'lodash/get'
export default {
  name: 'PasswordResetView',
  components: {
    FormViewBase,
    SetPasswordField,
    EmailField,
    SendPasswordResetButton,
  },
  props: {
    token: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      email: '',
      newPass: '',
      error: null,
      success: true,
    }
  },
  computed: {
    ...mapFields('snackbars', ['showPasswordUpdatedSnackbar']),
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),
    async updatePassword() {
      let { email, newPass: password, token } = this
      this.success = false
      this.$emit('sending')
      try {
        let { data: res } = await this.resetPassword({ email, password, token })
        this.success = true
        this.showPasswordUpdatedSnackbar = true
        let redirectPathName = RouteNames.Guest.HOME
        if (res.data.is_merchant) {
          redirectPathName = RouteNames.Merchant.LOGIN
        } else {
          redirectPathName = RouteNames.Customer.LOGIN
        }
        this.$router.push({ name: redirectPathName })
      } catch (error) {
        this.error = _get(
          error,
          'response.data.error.message',
          'Your password could not be reset.'
        )
      } finally {
        this.$emit('done')
      }
    }, // updatePassword
  },
}
</script>
